import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Selector = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3.5),
}));

export const AudienceButton = styled(ButtonBase, {
    shouldForwardProp: prop => prop !== '$active',
})<{ $active: boolean }>(({ theme, $active }) => ({
    minHeight: 60,
    padding: theme.spacing(0.75, 1.5),
    border: `1px solid ${$active ? theme.palette.primary.main : theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: $active ? 'rgba(52, 126, 62, 0.06)' : theme.palette.background.paper,
    position: 'relative',
    display: 'grid',
    gridTemplateColumns: 'auto minmax(0, 1fr)',
    gap: theme.spacing(1.5),
    textAlign: 'start',
    transition: theme.transitions.create(['border-color', 'background-color', 'box-shadow']),
    '&:hover': {
        borderColor: theme.palette.primary.main,
        backgroundColor: 'rgba(52, 126, 62, 0.08)',
    },
    '&:focus-visible': {
        boxShadow: `0 0 0 3px ${theme.palette.primary.main}33`,
    },
    '&::after': {
        content: $active ? '""' : 'none',
        position: 'absolute',
        top: '100%',
        insetInlineStart: theme.spacing(4),
        width: 0,
        height: 0,
        borderInlineStart: '7px solid transparent',
        borderInlineEnd: '7px solid transparent',
        borderTop: `7px solid ${theme.palette.primary.main}`,
    },
    [theme.breakpoints.down('sm')]: {
        minHeight: 56,
        padding: theme.spacing(0.5, 1),
        gap: theme.spacing(1),
        '&::after': {
            insetInlineStart: theme.spacing(3),
        },
    },
}));

export const AudienceIcon = styled('span', {
    shouldForwardProp: prop => prop !== '$active',
})<{ $active: boolean }>(({ theme, $active }) => ({
    width: 38,
    height: 38,
    borderRadius: '50%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: $active ? theme.palette.common.white : theme.palette.text.secondary,
    backgroundColor: $active ? theme.palette.primary.main : theme.palette.action.hover,
    [theme.breakpoints.down('sm')]: {
        width: 34,
        height: 34,
    },
}));

export const AudienceText = styled('span')({
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
});
